import { render, staticRenderFns } from "./web_health_network.vue?vue&type=template&id=25d6d640&scoped=true&v-once=true"
import script from "./web_health_network.vue?vue&type=script&lang=js"
export * from "./web_health_network.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d6d640",
  null
  
)

export default component.exports